var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline-item',{attrs:{"color":"blue","large":"","icon":"far fa-shoe-prints"}},[_c('div',{staticClass:"title pt-3"},[_vm._v("Walked to a new room")])])}
var staticRenderFns = []

export { render, staticRenderFns }